<script>
import {mapGetters} from 'vuex'
import Settings from '../../../mixins/edit/Settings'
export default {
    name: 'settings-stacked-offer',

    mixins: [Settings],

    watch:
    {
        'item':
        {
            handler: 'fetchFilteredFields',
            immediate: true,
        }

    },

    methods:
    {
        async fetchFilteredFields()
        {
            this.filteredFields = await this.$store.dispatch('fieldsFetch', { client_id: this.item.client.id })
        }
    },

    data()
    {
        return {
            action:
            {
                update: 'stackedOfferUpdate',
            },
            subPageName: 'stacked-offers-subpages',
            id: 'stacked_offer_id',
            filteredFields: [],
        }
    },
}
</script>
<template lang="html">
    <div >
        <div class="py-5 border-sides-1-secondary border-bottom-1-secondary" >
            <div class="px-3">
                <div class="row mb-3">
                    <div class="col-2 text-right pt-1 font-weight-bold">
                        ESP
                    </div>
                    <div class="col-6">
                        <custom-multiselect
                            searchable
                            :options="['drip', 'mailchimp', 'sendgrid', 'klaviyo']"
                            v-model="item.esp_type"
                            :selectedValue="item.esp_type"
                            @selected="item.esp_type = $event"
                            >

                        </custom-multiselect>
                    </div>
                </div>
            </div>
            <div class="px-3">
                <div class="row mb-3">
                    <div class="col-2"></div>
                    <div class="col-10">
                        <simple-input
                        type="text"
                        preText="Account ID"
                        v-model="item.esp_account"
                        class="smaller-pretext bold"
                        ></simple-input>
                    </div>
                </div>
                <div class="row mb-3" v-if="item && item.esp_type != 'klaviyo'">
                    <div class="col-2"></div>
                    <div class="col-10">
                        <simple-input
                        type="text"
                        preText="API Token"
                        v-model="item.esp_token"
                        class="smaller-pretext bold"
                        ></simple-input>
                    </div>
                </div>
            </div>
            <div class="px-3" v-if="item && item.esp_type != 'klaviyo'">
                <div class="row mb-3">
                    <div class="col-2"></div>
                    <div class="col-10">
                        <simple-input
                        type="text"
                        preText="Campaign ID"
                        v-model="item.esp_campaign_id"
                        class="smaller-pretext bold"
                        ></simple-input>
                    </div>
                </div>
            </div>
            <div class="px-3" v-if="item && item.esp_type == 'klaviyo'">
                <div class="row mb-3">
                    <div class="col-2"></div>
                    <div class="col-10">
                        <simple-input
                        type="text"
                        preText="Event name"
                        v-model="item.esp_campaign_id"
                        class="smaller-pretext bold"
                        ></simple-input>
                    </div>
                </div>
            </div>
            <div class="row mb-3" v-if="item && item.esp_type == 'mailchimp'">
                <div class="col-2"></div>
                <div class="col-10">
                    <tags-input
                        preText="Tags"
                        v-model="item.esp_tags"
                        class="smaller-pretext bold">
                    </tags-input>
                </div>
            </div>
            <div class="px-3">
                <div class="row mb-3">
                    <div class="col-2 text-right pt-2 font-weight-bold">
                        Offer price
                    </div>
                    <div class="col-2">
                        <simple-input
                        preText="$"
                        type="number"
                        isMoney
                        min=0
                        v-model="item.price"
                        noRadius
                        ></simple-input>
                    </div>
                </div>
            </div>
            <div class="px-3 border-top-1-secondary pt-4">
                <div class="row">
                    <div class="col-12">
                        <div class="border border-radius-4-top">
                            <table class="create-offer-fields">
                                <thead>
                                    <tr class="border-radius-4-top">
                                        <th colspan="2">
                                            Select data fields to collect
                                        </th>
                                    </tr>
                                </thead>
                                <tbody v-if="fields">
                                    <tr v-for="(field, index) in filteredFields" :class="{'grey-bg': !item.name}">
                                        <td style="width:10%" class="text-center">
                                            <switcher
                                                class="d-inline-block mr-2"
                                                @input="setField($event, field)"
                                                :value="item.fields.getBy('id', field.id).id"
                                            ></switcher>
                                        </td>
                                        <td style="width:90%">
                                            <strong>{{ field.label }} ({{field.name}})</strong> <br>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="grey-bg border-bottom-1-secondary border-sides-1-secondary px-3 py-2">
            <div class="row">
                <div class="col-3">
                    <custom-button v-if="false" classes="white text-desc-color xs" iconBeforeText="fas fa-eye mr-2" text="Preview" @buttonClick="preview" ></custom-button>
                </div>
                <div class="col-9 text-right">
                    <custom-button classes="white text-desc-color w-120" text="Discard" @buttonClick="discard"></custom-button>
                    <custom-button classes="blue text-white w-120" text="Save" @buttonClick="save"></custom-button>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/pages/stackedoffers/edit/Settings.vue